module.exports = __webpack_public_path__ + "static/img/10.9b1fa17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/10.png
// module id = P3em
// module chunks = 35